export enum PersonStatus {
   APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
   WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
   WAITING_FOR_IPN = 'WAITING_FOR_IPN',
   NEW_APPLICANT = 'NEW_APPLICANT',
   REVISED_WAITING_FOR_SYNC = 'REVISED_WAITING_FOR_SYNC',
   NEEDS_CORRECTION = 'NEEDS_CORRECTION',
   SYNCED = 'SYNCED',
   NONE = 'NONE',
   REGISTERED = 'REGISTERED',
   TRASH = 'TRASH'
}

export enum ChaosTableStudentStatus {
   APPLICATION_STARTED = 'APPLICATION_STARTED',
   APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
   REGISTERED = 'REGISTERED',
   WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
   WAITING_FOR_IPN = 'WAITING_FOR_IPN',
   NEEDS_CORRECTION = 'NEEDS_CORRECTION',
   NEW_APPLICANT = 'NEW_APPLICANT',
   REVISED_WAITING_FOR_SYNC = 'REVISED_WAITING_FOR_SYNC',
   REVISED_NEEDS_CORRECTION = 'REVISED_NEEDS_CORRECTION',
   SYNCED = 'SYNCED',
   TRASH = 'TRASH',
   EXPIRED_LINK = 'EXPIRED_LINK',
   NONE = 'NONE',
   ALREADY_MEMBER = 'ALREADY_MEMBER'
}
